module.exports = __webpack_public_path__ + "static/peach-ae8ccaedd143a5d3bf329674ed91f669.svg";